import { createSelector } from "reselect";

export const getMeId = state => state.me.user;
const getUsers = state => state.entities.users;

/*****************
 *
 * EXPORT METHODS
 *
 *****************/

export const getMe = state =>
    createSelector(getMeId, getUsers, (meId, users) => {
        return users[meId];
    })(state);
